import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { CommonLoginSdkModule } from "@obg/common.login/sdk/module";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { CommonValidationRendererModule } from "@obg/ngx.ui.common";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { ForgotPasswordEmailContainer } from "./forgot-password-email.container";

const DIRECTIVES = [ForgotPasswordEmailContainer];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSelectModule,
		CoreContentModule,
		CoreUiModule,
		RouterModule,
		CommonValidationRendererModule,
		CommonLoginSdkModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ForgotPasswordEmailUiModule {}
